import { render } from "./footer.vue?vue&type=template&id=2d795658&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=2d795658&lang=less&scoped=true"

import exportComponent from "D:\\2018 -2020 工作\\2020 中创\\Projects\\frontend\\publicity\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d795658"]])

export default __exports__